import { createStyles, Theme } from '@mui/material'

const styles = ({ palette }: Theme) =>
  createStyles({
    placeHolderRow: {
      backgroundColor: palette.grey['100'],
    },
    row: {
      transition: 'all 0.1s cubic-bezier(0.4, 0, 0.2, 1)',
      cursor: 'pointer',
    },
    cell: {
      textOverflow: 'ellipsis',
    },
  })

export default styles
